import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShieldCrossed: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="shield-crossed, security, protection"><path d="M14.2258 13.7492L11.9882 11.4999M11.9882 11.4999L9.75 9.25M11.9882 11.4999L14.2258 9.25022M11.9882 11.4999L9.75 13.75M12 2.75L20.25 5.5V11.9123C20.25 16.8848 16 19.25 12 21.4079C8 19.25 3.75 16.8848 3.75 11.9123V5.5L12 2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconShieldCrossed;
